import { Component, inject } from '@angular/core';
import { ProgressService } from '../../lib/progress.service';
import { LoadingComponent } from '../../loading/loading.component';

@Component({
  selector: 'app-success',
  imports: [LoadingComponent],
  templateUrl: './success.component.html',
})
export class SuccessComponent {
  public progressService = inject(ProgressService);
}
